// extracted by mini-css-extract-plugin
export default {"root":"Avatar__root--1n6DO"};